import { theme, backdrop_opacity } from "./settings";
import { MeowLightboxMetadata } from "./metadata/MeowLightboxMetadata";
import { MeowLightboxSlider } from "./sliders/MeowLightboxSlider";
import { MeowLightboxTopbar } from "./topbar/MeowLightboxTopbar";
import { Navigation } from "./navigations/Navigation";

const themeBackdropColor = { light: 255, dark: 0 };
const backdropValue = `rgba(${themeBackdropColor[theme]}, ${themeBackdropColor[theme]}, ${themeBackdropColor[theme]}, ${backdrop_opacity/100})`;

export const MeowLightbox = () => {
  return (
    <div className={`mwl ${theme}`} style={{ background: backdropValue }}>
      <MeowLightboxTopbar className="mwl__topbar" />
      <Navigation className="mwl__navigations" />
      <MeowLightboxSlider className="mwl__slider" />
      <MeowLightboxMetadata className="mwl__metadata" />
    </div>
  );
};
